import type { OptionInput, SubOptionItemInput } from "@/lib/gql/__generated__/graphql";

import type { ProductOptionFormModel } from "../../../type";

type Props = {
	viewModel: ProductOptionFormModel["ViewModel"];
};

export const viewModelToOptionInputConverter = ({ viewModel }: Props): OptionInput => {
	const input: OptionInput = {
		hotelID: viewModel.hotelID,
		optionID: viewModel.optionID,

		name: viewModel.name.value,

		optionType: viewModel.optionType.value,

		availablePlanIDs: viewModel.availablePlanIDs.value.map((item) => item.value),

		billingTypeTarget: viewModel.billingTypeTarget.value,
		billingTypeTerm: viewModel.billingTypeTerm.value,
		cancelPolicy: viewModel.cancelPolicy.value.map((item) => {
			return {
				chargeRatio: item.chargeRatio.value,
				beforeDays: item.beforeDays.value,
			} satisfies OptionInput["cancelPolicy"][0];
		}),
		description: viewModel.description.value,
		inSale: viewModel.inSale.value,
		isNextMorning: viewModel.isNextMorning.value,
		isNotDiscountTarget: viewModel.isNotDiscountTarget?.value ?? false,
		keyVisuals: viewModel.keyVisuals.value.map((kv) => {
			return {
				bucket: kv.bucket.value,
				key: kv.key.value,
				region: kv.region.value,
				mimeType: kv.mimeType?.value,
				fileName: kv.fileName?.value,
			} satisfies OptionInput["keyVisuals"][0];
		}),
		mainKeyVisual: {
			bucket: viewModel.mainKeyVisual.bucket.value,
			key: viewModel.mainKeyVisual.key.value,
			region: viewModel.mainKeyVisual.region.value,
			mimeType: viewModel.mainKeyVisual.mimeType?.value,
			fileName: viewModel.mainKeyVisual.fileName?.value,
		} satisfies OptionInput["mainKeyVisual"],

		maxBuyableNumPerTarget: viewModel.maxBuyableNumPerTarget?.value,
		maxDailyStockNum: viewModel.maxDailyStockNum?.value,
		maxStockNum: viewModel.maxStockNum?.value,
		minimumBuyableNumPerTarget: viewModel.minimumBuyableNumPerTarget?.value,

		price: {
			// eslint-disable-next-line @typescript-eslint/no-non-null-asserted-optional-chain
			amount: viewModel.price.amount?.value,
			currencyType: viewModel.price.currencyType.value,
		} satisfies OptionInput["price"],

		requiredPrepMillisecond: viewModel.requiredPrepMillisecond.value,

		saleEnd: viewModel.saleEnd?.value || undefined,
		saleStart: viewModel.saleStart?.value || undefined,
		saleStartBeforeDate: viewModel.saleStartBeforeDate?.value,
		saleTypeForPlan: viewModel.saleTypeForPlan.value,
		saleTypeForTerm: viewModel.saleTypeForTerm.value,

		stayableDayOfTheWeek: viewModel.stayableDayOfTheWeek?.value.map((item) => item.value),
		stayableEnd: viewModel.stayableEnd?.value || undefined,
		stayableStart: viewModel.stayableStart?.value || undefined,

		subOptions: viewModel.subOptions?.value?.map((item) => {
			return {
				endAt: item.endAt?.value,
				isNextMorning: item.isNextMorning?.value,
				isShowTimeSchedule: item.isShowTimeSchedule?.value,
				maxDailyStockNum: item.maxDailyStockNum.value,
				memo: item.memo?.value,
				name: item.name.value,
				price: {
					amount: item.price.amount.value,
					currencyType: item.price.currencyType.value,
				},
				startAt: item.startAt?.value,
				subOptionID: item.subOptionID?.value,
			} satisfies SubOptionItemInput;
		}),
		useAsSubOption: viewModel.useAsSubOption.value,
		multiSubOptionSelectable: viewModel.multiSubOptionSelectable.value,
		isDateTabbedTimeSelectionEnabled: viewModel.isDateTabbedTimeSelectionEnabled.value,
		isHolidayStayable: viewModel.isHolidayStayable?.value ?? undefined,
	} satisfies OptionInput;

	return input;
};
